<template>
  <div class="attachment-container">
    <!-- TODO: add animation if dragging the file here -->
    <div v-if="isDragging" class="drag-overlay"></div>
    <div
      class="attachment-field d-flex flex-column align-items-center justify-content-center gap-3"
      @drop="handleDrop"
      @dragover="handleDragOver"
      @dragleave="handleDragLeave"
    >
      <div
        v-if="fileName"
        class="attachment-field__file-attached d-flex flex-column align-items-center justify-content-center gap-2"
      >
        <img src="@/assets/images/import/xls-icon.png" width="43" />
        <p>{{ fileName }}</p>

        <b-spinner v-if="isLoading" />
      </div>

      <div v-else class="attachment-field__empty-state">
        <p>{{ $t('master.multiImei.import.chooseFile') }}</p>
        <p>{{ $t('master.multiImei.import.maxFile2MB') }}</p>
      </div>

      <McButton
        :text="$t('master.multiImei.import.selectFile')"
        variant="secondary"
        @click="handleLoadFile"
        :disabled="isLoading"
      />

      <input
        type="file"
        ref="file-input-ref"
        :accept="fileAccepted.join(', ')"
        @change="handleFileChanged"
        hidden
      />
    </div>
  </div>
</template>

<script>
import McButton from '@/components/McButton'
import * as vehicleApi from '@/services/rest-api-sms/lib/vehicle/vehicle'

export default {
  components: {
    McButton,
  },
  emits: ['update:isDisableNextBtn'],
  data() {
    return {
      isLoading: false,
      isDragging: false,
      fileName: '',
      fileSize: null,
      file: undefined,
      base64: null,
    }
  },

  computed: {
    fileAccepted() {
      return ['.csv', '.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']
    },
  },

  methods: {
    async HandleProcessFile() {
      if (!this.base64) return
      const response = await vehicleApi.importMultiImei({ base64: this.base64 })
      if (
        response.status === 500 &&
        response.data.message == this.$t('master.multiImei.import.templateErrorMessage')
      ) {
        let errorMessage = 'Unggah gagal. Template file tidak sesuai'
        this.$toast.error(errorMessage)
        this.resetInputFile(event)
        return
      }
      this.redirectToProcessFile(response?.data)
    },

    redirectToProcessFile(uploadedFile) {
      this.$router.push({
        name: 'Multi IMEI Import Detail',
        params: {
          file: uploadedFile ?? null,
        },
      })
    },

    handleLoadFile() {
      if (this.isLoading) {
        this.$toast.warning('Mohon Tunggu')
        return
      }

      this.$refs['file-input-ref'].click()
    },

    handleDragOver(event) {
      event.preventDefault()
      this.isDragging = true
    },

    handleDragLeave() {
      this.isDragging = false
    },

    handleDrop(event) {
      event.preventDefault()

      this.isLoading = true
      this.file = event.dataTransfer.files[0]

      this.isDragging = false
      this.uploadFile()
    },

    resetInputFile(event) {
      this.fileName = ''
      this.fileSize = null
      this.file = undefined

      if (event) {
        event.target.value = ''
      }

      this.isLoading = false
    },

    handleFileChanged(event) {
      this.isLoading = true

      const [file] = event.target.files
      if (!file) {
        this.isLoading = false
        return
      }

      this.file = file
      this.uploadFile(event)
    },

    async uploadFile(event = undefined) {
      if (!this.fileAccepted.includes(this.file.type)) {
        this.$toast.error('Unggah gagal. Format file tidak sesuai.')

        this.resetInputFile(event)
        return
      }
      const files = event.target.files
      this.file = files[0]
      const toBase64 = (file) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.readAsDataURL(file)
          reader.onload = () => resolve(reader.result)
          reader.onerror = (error) => reject(error)
        })
      const convertedBase64 = await toBase64(this.file)
      this.base64 = convertedBase64.split(',')[1]

      let fileSize = this.file.size
      const MAX_FILE_SIZE = 1024 * 1024 * 2 // 2MB
      if (fileSize > MAX_FILE_SIZE) {
        this.$toast.error('Unggah gagal. Ukuran file melebihi batas ketentuan.')
        this.resetInputFile(event)
        return
      }

      this.fileName = this.file.name
      fileSize = this.file.size / 1024 / 1024
      this.fileSize = fileSize.toFixed(2)
      this.$emit('update:isDisableNextBtn', false)
      this.isLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
.attachment-container {
  position: relative;
  width: 100%;
  height: 100%;

  .attachment-field {
    border: 2px dashed $mep-primary-100;
    border-radius: 4px;
    width: 100%;
    height: 100%;

    p {
      line-height: 20px;
      margin: 0;
      text-align: center;
    }

    &__empty-state {
      color: $mep-color-text-300;
    }

    &__file-attached {
      width: 75%;
      text-align: center;
      font-weight: 600;
    }

    &__progress-bar {
      width: 100%;
    }
  }
}
</style>
